import { Button, Stack, TextField, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { StyledBox } from './styled';
import { useEditCategoryLogic } from './useEditCategoryLogic';

const EditCategory = () => {
  const {
    methods,
    errors,
    isLoading,
    isSuccess,
    onSubmit,
    register,
    handleSubmit,
  } = useEditCategoryLogic();

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
        sx={{
          gap: '10px',
          '.MuiFormHelperText-root': {
            margin: '0px'
          }
        }}
      >
        <Typography variant="h5">
          Update Category
        </Typography>
        <StyledBox>
          <TextField
            {...register('titleAm')}
            label="Title Am"
            error={!!errors.titleAm}
            helperText={errors.titleAm ? 'Title is required' : ''}
          />
          <TextField
            label="Title En"
            error={!!errors.titleEn}
            helperText={errors.titleEn ? 'Title is required' : ''}
            {...register('titleEn')}
          />
          <TextField
            label="Title Ru"
            error={!!errors.titleRu}
            helperText={errors.titleRu ? 'Title is required' : ''}
            {...register('titleRu')}
          />
        </StyledBox>
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          Submit
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default EditCategory;
